import { Guard_VerifyAlphaNumericGuard as verifyAlphaNumeric } from "./backend"
import Checkout from '@/api/checkout-api'

const noopGuard = {
    name: () => '',
    isClear: () => true,
    attribute: () => false,
    // eslint-disable-next-line 
    verify: (input) => true,
    isOptional: () => true,
}

const verifyNumber = async (input, order) => {
    let res = await verifyAlphaNumeric({
        req: {
            orderId: order.id,
            key: order.token,
            input: input
    }});
    return res.data;
}



const numberGuard = {
    name: () => process.env.VUE_APP_GUARD_NAME,
    isClear: async () => { 
        const value = localStorage.getItem('GUARD_NUMBER');
        if(value){
            const order = await Checkout.createOrderIfNeeded();
            let data = await verifyNumber(value, order);
            return data.success;
        }
        return false;
    },
    verify: async (input) => {
        const order = await Checkout.createOrderIfNeeded();
        let  data = await verifyNumber(input, order);
        if(data.success){
            localStorage.setItem('GUARD_NUMBER', input);
            return true;
        }
        return false;
    },
    isOptional: () => false,
}

const optNumberGuard = {
    name: () => process.env.VUE_APP_GUARD_NAME,
    isClear: async () => { 
        const value = localStorage.getItem('GUARD_NUMBER');
        if(value){
            const order = await Checkout.createOrderIfNeeded();
            let data = await verifyNumber(value, order);
            return data.success;
        }else if (localStorage.getItem('GUARD_NUMBER_OPTED')){
            return true;
        }
        return false;
    },
    verify: async (input) => {
        const order = await Checkout.createOrderIfNeeded();
        let  data = await verifyNumber(input, order);
        if(data.success){
            if(input){
                localStorage.setItem('GUARD_NUMBER', input);
            }
            else {
                localStorage.setItem('GUARD_NUMBER_OPTED', true);
            }
            return true;
        }
        return false;
    },
    isOptional: () => true,
}



export const GuardFactory = () => {
    const provider = process.env.VUE_APP_GUARD;
    switch(provider){
        case 'opt_number':
            return optNumberGuard;
        case 'number':
            return numberGuard;
        default:
            return noopGuard;
    }
}




